async function importPolyfill(): Promise<typeof import ('@lpi/text-encoder-lite').default> {
    const module = await import(
        /* webpackChunkName: 'text-encoder-lite' */
        '@lpi/text-encoder-lite'
    );

    return module.default;
}

async function createTextEncoder(useNativeEncoder: boolean): Promise<TextEncoder> {
    if (useNativeEncoder) {
        return new TextEncoder();
    }

    const polyfill = await importPolyfill();

    return new polyfill.TextEncoderLite();
}

async function createTextDecoder(useNativeDecoder: boolean): Promise<TextDecoder> {
    if (useNativeDecoder) {
        return new TextDecoder();
    }

    const polyfill = await importPolyfill();

    return new polyfill.TextDecoderLite();
}

export async function encode(toEncode: string, window: Window): Promise<Uint8Array> {
    const useNativeEncoder = 'TextEncoder' in window;
    const encoder = await createTextEncoder(useNativeEncoder);

    return encoder.encode(toEncode);
}

export async function decode(toDecode: Uint8Array, window: Window): Promise<string> {
    const useNativeDecoder = 'TextDecoder' in window;
    const decoder = await createTextDecoder(useNativeDecoder);

    return decoder.decode(toDecode);
}
